import { type PropsWithChildren } from "react";

import { cx } from "../cx";

interface RootProps {
  "aria-label": string;
  hidden?: boolean;
}

export const Root = ({
  children,
  "aria-label": ariaLabel,
  hidden = false,
}: Readonly<PropsWithChildren<RootProps>>) => (
  <nav
    data-testid="circle-ai-shell-dock"
    data-circle-ai-shell-dock=""
    aria-label={ariaLabel}
    aria-hidden={hidden || undefined}
    inert={hidden || undefined}
    className={cx(
      "group/dock duration-[240ms] ease-[cubic-bezier(0.32,0.72,0,1)] relative z-20 h-full min-h-0 shrink-0 overflow-hidden border-r border-primary bg-secondary transition-[width] motion-reduce:transition-none",
      {
        "w-0": hidden,
        "w-[var(--shell-dock-w)]": !hidden,
      },
    )}
  >
    <div className="absolute inset-y-0 left-0 flex min-h-0 w-[var(--shell-dock-w)] flex-col">
      {children}
    </div>
  </nav>
);

Root.displayName = "CircleAIAppShell.Layout.Dock";
